import styled from 'styled-components';

export const ChatArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: hidden;
  height: 100%;
`;

export const ChatArea__Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
`;

export const ChatArea__InputWrap = styled.div`
  flex-shrink: 0;
`;
